<template>
  <v-row :style="'background-color:' + $finColors.primaryLight" class="fill-height ma-0 pa-6 pl-5">
    <v-col cols="12">
      <p class="academy-title mb-3" style="font-size: 20px">
        <v-icon class="pr-2">icon-lexicon</v-icon>
        finLexikon
      </p>
      <p>
        <fin-lexicon-text
          auto-solve
          text="Suchen und finde Fachbegriffe der Börsenwelt und lerne so das Vokabular der Profis kennen."/>
      </p>
    </v-col>
    <v-col cols="12" >
      <v-btn class="d-flex float-right float-sm-left align-self-end"
             outlined
             light
             @click="openLexicon">
        Los geht’s
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import FinLexiconText from "@/components/common/lexicon/LexiconText"
import {EventBus} from "@/plugins/fincraft"

export default {
  name: "FinAcademyLexicon",
  components: {FinLexiconText},
  methods:{
    openLexicon(){
      EventBus.$emit("showLexicon", undefined, undefined, true)
    }
  }
}
</script>

<style lang="scss" scoped>

.academy-title {
  font-family: TiemposText;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}
</style>
